export default "__VITE_ASSET__BSeYjm1W__"